import React from 'react';

import { BoxProps, Flex, ScrollArea, Title } from '@mantine/core';

interface OrganisationSectionWrapperProps extends BoxProps {
  title: string;
  rightComponent?: React.ReactNode;
  withMarginBottom?: boolean;
  children: React.ReactNode;
}

export function OrganisationSectionWrapper({
  title,
  rightComponent,
  withMarginBottom,
  children,
  ...boxProps
}: OrganisationSectionWrapperProps) {
  return (
    <Flex h="100%" direction="column" {...boxProps}>
      <Flex direction="row" align="flex-start" justify="space-between" w="100%" mb={withMarginBottom ? 10 : 0}>
        <Title order={4}>{title}</Title>

        {rightComponent}
      </Flex>
      <ScrollArea h="100%">{children}</ScrollArea>
    </Flex>
  );
}
